import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import jsxToString from 'jsx-to-string';
import ReactHtmlParser from 'react-html-parser';
import Select from 'react-select';
import {FeedingController} from '../controllers/Feeding';
import MealFedModal from "./MealFedModal";
import {food} from '../constants';
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Input,
//   Label
// } from "reactstrap";
import '../styles/feeding.css';


export const SmartFeedingForm  = class SmartFeedingForm extends Component {
  constructor() {
    super();
    this.state = {
      results: false,
      message: null,
      food_list: [],
      breast_feeding: null,
      meal_submitted: false,
    };
  }



  onSubmit = (e) => {
    const {breast_feeding}= this.state;
    let results;
    if(breast_feeding !== null && breast_feeding !== ""){
      results = FeedingController.getSmartFeedingMenu(this.state.food_list, this.state.breast_feeding, this.props.Child, this.props.age, this.props.Translator);
      this.setState({message: results, results: true});
    }
    else{
      this.setState({submitted: false, breast_option_error: 'Chagua kama mtoto ananyonya au hanyonyi'});
    }
  }

  onMealFoodListSave = (e) => {
    const state = this.state
    if(this.state.food_list.length !== 0 && this.state.food_list.length <= 3){
      state.meal_submitted = true;
      state.food_list_error = '';
      this.setState(state);
    }
    else{
      if (this.state.food_list.length === 0)
        this.setState({food_list_error: 'Hujachagua chakula'});
      else if ( food.length > 3)
        this.setState({food_list_error: 'Umechagua vyakula zaidi ya vitatu, punguza'});
    }
  }

  onMealFoodListChange = (data) => {
    let food_list = this.state.food_list;
    if(data.length !== 0){
      food_list = data;
    }
    this.setState({food_list: food_list});
  }

  onBreastFedChange = (e) => {
    const state = this.state
    const option= e.target.value;
    state.breast_feeding = option;
    this.setState(state);
  }

  componentDidMount() {
    // this.initializeData();
  }

  render() {
    const { Translator, Child, age} = this.props;
    const translation = this.props.Translator;
    const food_list = FeedingController.showMealList("Yes", Translator);

    return (
      <div>
        {/* {!this.state.submitted ? ( */}
          <div className="col-sm-12 col-md-12 col-xs-12" style={{padding: "0px",height: "100%",overflowY: "scroll",overflowX: "hidden"}}>

              <div style={{height: "100%",padding: "0px;margin: 0px"}}>
                <div className="container-fluid">
                  <div className="row">
                    {this.state.results ? (
                      <div className="col-xs-12 col-sm-12 col-md-12" style={{paddingBottom: "20px",height: "auto",marginTop: "30px"}}>
                        <div style={{backgroundColor: "hsl(120, 50%, 40%)",padding: "10px",borderRadius: "4px"}}>{ReactHtmlParser(this.state.message)}</div>
                      </div>
                    ) : (
                      <div className="col-xs-12 col-sm-12 col-md-12">
                        <form id="smart_feeding_form">
                          {!this.state.meal_submitted ? (
                            <div>
                              <div id="smart_feeding_menu_label" className="form-group">
                                <div className="card-title text-center" style={{paddingTop: "20px"}}>Orodhesha vyakula ambavyo umepanga kumlisha <b>{this.props.Child.first_name}</b> ndani ya saa 24 kwa kuchagua kwenye listi ya vyakula vilivyorodheshwa hapa chini.</div>
                              </div>
                          <div id="smart_feeding_error" style={{textAlign: "center"}}><font style={{color:"#ff0000", fontSize:"0.9em"}}>{this.state.food_list_error}</font></div>
                              <div id="smart_feeding_menu" className="form-group">
                                <label className="form-control-label"></label>
                                <Select options={food_list} isMulti styles = {{width: "700px"}} onChange={(opt) => this.onMealFoodListChange(opt)} />
                              </div>
                          </div>
                          ) : (
                            <div>
                              <div id="breast_feeding_opt_label" className="form-group">
                                <div className="card-title text-center" style={{paddingTop: "20px"}}>Je, <b>{this.props.Child.first_name}</b> ananyonya?</div>
                              </div>
                              <div id="breast_feeding_error" style={{textAlign: "center"}}><font style={{color:"#ff0000", fontSize:"0.9em"}}>{this.state.breast_option_error}</font></div>
                              <div id="breast_feeding_opt" class="form-group">
                                <label className="form-control-label"></label>
                                <select id="smart_breast_feeding" className="form-control" onChange={this.onBreastFedChange}>
                                  <option value="">Chagua</option>
                                  <option value="Ndiyo">Ndiyo</option>
                                  <option value="Hapana">Hapana</option>
                                </select>
                              </div>
                            </div>
                          )}
                          {!this.state.meal_submitted ? (
                            <div id="smart_next_btn" className="card-footer text-center">
                              <button type="button" onClick = {this.onMealFoodListSave} className="btn btn-md" id="smart_feeding_next_btn" style={{width: "80px",borderRadius: "0px"}}>Endelea</button>
                            </div>
                          ) : (
                            <div id="smart_save_btn" className="card-footer text-center">
                              <button type="button" onClick = {this.onSubmit} className="btn btn-md" id="smart_feeding_btn" style={{width: "80px",borderRadius: "0px"}}>Tunza</button>
                            </div>
                          )}
                        </form>
                      </div>	
                    )}
                  </div>
                </div>
              </div>
          </div>
      </div>
    );
  }
}

export default SmartFeedingForm;